export class UserDetails {
  userId: string;
  clientId: number;
  email: string;
  name: string;
  preferredUsername: string;
  givenName: string;
  familyName: string;
  roles: Array<string>;
}
